import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n'
import { ref, onMounted, computed, Ref } from 'vue'
import { Applicant, Message, RequestResponse, Subscriber } from '@/types'
import { broadcastingActions } from '@/stores/broadcasting-store'
import { Delta } from '@vueup/vue-quill'
import MessageBox from '@/components/Static/MessageBox/MessageBox.vue'
import MessageTable from '@/components/Static/MessageTable/MessageTable.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageComponent',
  setup(__props) {

const messages = ref<Message[]>([])

const loading = ref(false)
const { t } = useI18n()
const broadcasting = broadcastingActions()

const page = ref(1)
const itemsPerPage = ref(5)
const removeSubscriberResponse = ref<RequestResponse>()
const requestResponse = ref<RequestResponse>()
const content = ref<Delta>()
const editContent = ref(false)
const id = ref<string>('')
const title = ref<string>('')
const headers = computed(() => {
  return [
    {
      title: 'Photo',

      key: 'photo',
      sortable: false,
      align: 'center',
    },
    { title: t('title'), key: 'title', sortable: false, align: 'center' },
    {
      title: t('table.created-at'),
      key: 'createdAt',
      sortable: false,
      align: 'center',
    },

    {
      title: t('table.update'),
      key: 'action',
      sortable: false,
      align: 'center',
    },
  ]
})

onMounted(() => {
  loadMessages()
})

const closeDialog = () => {
  editContent.value = false
  loadMessages()
}

const loadMessages = async () => {
  loading.value = true
  const docToken = localStorage.getItem('docAccessToken') ?? ''
  const response = await broadcasting.getMessages(
    page.value,
    itemsPerPage.value,
    docToken
  )
  requestResponse.value = response
  if (response.success) {
    messages.value = response.result as Message[]
  }

  loading.value = false
}

const editMessage = async (event: any) => {
  content.value = event.content
  id.value = event.id
  title.value = event.title
  editContent.value = !editContent.value
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value)
      ? (_openBlock(), _createBlock(_component_request_status, {
          key: 0,
          response: requestResponse.value
        }, null, 8, ["response"]))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createBlock(MessageTable, {
          key: 1,
          messages: messages.value,
          isDoctor: true,
          onEdit: _cache[0] || (_cache[0] = ($event: any) => (editMessage($event)))
        }, null, 8, ["messages"]))
      : _createCommentVNode("", true),
    (editContent.value)
      ? (_openBlock(), _createBlock(MessageBox, {
          key: 2,
          content: content.value,
          id: id.value,
          title: title.value,
          editView: true,
          studentView: false,
          broadcast: editContent.value,
          onClosed: closeDialog,
          onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (editContent.value = false))
        }, null, 8, ["content", "id", "title", "broadcast"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})